import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0d1b2e]">
      {/* ヘッダー */}
      <header className="bg-[#071020] border-b border-slate-800">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <span className="text-2xl font-bold text-amber-400 tracking-wide">ProjectMaster</span>
          </Link>
          <Link
            to="/"
            className="text-sm text-slate-400 hover:text-amber-400 transition-colors flex items-center gap-1"
          >
            <i className="ri-arrow-left-line"></i>
            トップページへ戻る
          </Link>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-white mb-8 text-center">利用規約</h1>

        <div className="bg-[#071020] rounded-lg p-8 text-slate-300 space-y-8">
          <section>
            <p className="text-sm text-slate-400 mb-6">
              この利用規約（以下「本規約」といいます）は、AtZBusinessPartners株式会社（以下「当社」といいます）が提供する「ProjectMaster」（以下「本サービス」といいます）の利用条件を定めるものです。本サービスをご利用いただく際には、本規約に同意いただいたものとみなします。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第1条（適用）
            </h2>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
              <li>本規約は、本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。</li>
              <li>当社が本サービス上で掲載する本サービス利用に関するルール等は、本規約の一部を構成するものとします。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第2条（定義）
            </h2>
            <p className="text-sm leading-relaxed mb-3">本規約において使用する用語の定義は、以下のとおりとします。</p>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
              <li>「本サービス」とは、当社が運営するDX・戦略コンサルティング領域に特化したフリーランス向け案件紹介プラットフォーム「ProjectMaster」を意味します。</li>
              <li>「ユーザー」とは、本サービスを利用する全ての個人または法人を意味します。</li>
              <li>「登録情報」とは、ユーザーが本サービスの利用にあたり当社に提供した情報を意味します。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第3条（登録）
            </h2>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
              <li>本サービスの利用を希望する者は、本規約を遵守することに同意し、当社が定める方法により登録を申請するものとします。</li>
              <li>当社は、登録申請者が以下のいずれかに該当する場合、登録を拒否することがあります。
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>本規約に違反するおそれがあると当社が判断した場合</li>
                  <li>登録情報に虚偽、誤記または記載漏れがあった場合</li>
                  <li>過去に本サービスの利用停止等の措置を受けたことがある場合</li>
                  <li>その他、当社が登録を適当でないと判断した場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第4条（禁止事項）
            </h2>
            <p className="text-sm leading-relaxed mb-3">ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>当社、本サービスの他のユーザー、または第三者の知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為</li>
              <li>本サービスを通じ、以下に該当し、または該当すると当社が判断する情報を送信する行為
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>過度に暴力的な表現を含む情報</li>
                  <li>コンピューター・ウィルスその他の有害なプログラムを含む情報</li>
                  <li>当社、本サービスの他のユーザーまたは第三者の名誉または信用を毀損する表現を含む情報</li>
                  <li>過度にわいせつな表現を含む情報</li>
                  <li>差別を助長する表現を含む情報</li>
                  <li>自殺、自傷行為を助長する表現を含む情報</li>
                  <li>反社会的な表現を含む情報</li>
                  <li>他人に不快感を与える表現を含む情報</li>
                </ul>
              </li>
              <li>本サービスのネットワークまたはシステム等に過度な負荷をかける行為</li>
              <li>当社が提供するソフトウェアその他のシステムに対するリバースエンジニアリングその他の解析行為</li>
              <li>本サービスの運営を妨害するおそれのある行為</li>
              <li>当社のネットワークまたはシステム等への不正アクセス</li>
              <li>第三者に成りすます行為</li>
              <li>本サービスの他のユーザーのIDまたはパスワードを利用する行為</li>
              <li>当社が事前に許諾しない本サービス上での宣伝、広告、勧誘、または営業行為</li>
              <li>本サービスの他のユーザーの情報の収集</li>
              <li>当社、本サービスの他のユーザーまたは第三者に不利益、損害、不快感を与える行為</li>
              <li>反社会的勢力等への利益供与</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第5条（本サービスの停止等）
            </h2>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
              <li>当社は、以下のいずれかに該当する場合には、ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合</li>
                  <li>コンピューター、通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング等により本サービスの運営ができなくなった場合</li>
                  <li>地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</li>
                  <li>その他、当社が停止または中断を必要と判断した場合</li>
                </ul>
              </li>
              <li>当社は、本条に基づき当社が行った措置によりユーザーに生じた損害について一切の責任を負いません。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第6条（権利帰属）
            </h2>
            <p className="text-sm leading-relaxed">
              本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第7条（保証の否認および免責）
            </h2>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
              <li>当社は、本サービスがユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、ユーザーによる本サービスの利用がユーザーに適用のある法令または業界団体の内部規則等に適合すること、および不具合が生じないことについて、何ら保証するものではありません。</li>
              <li>当社は、本サービスに起因してユーザーに生じたあらゆる損害について、一切の責任を負いません。ただし、本サービスに関する当社とユーザーとの間の契約が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。</li>
              <li>前項ただし書に定める場合であっても、当社は、当社の過失（重過失を除きます）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し、または予見し得た場合を含みます）について一切の責任を負いません。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第8条（利用規約の変更）
            </h2>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
              <li>当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。</li>
              <li>変更後の本規約は、当社が別途定める場合を除いて、本サービス上に表示した時点より効力を生じるものとします。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 border-b border-slate-700 pb-2">
              第9条（準拠法および管轄裁判所）
            </h2>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed">
              <li>本規約の準拠法は日本法とします。</li>
              <li>本規約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
            </ol>
          </section>

          <section className="pt-6 border-t border-slate-700">
            <p className="text-sm text-slate-400">制定日：2025年1月1日</p>
            <p className="text-sm text-slate-400 mt-2">
              <strong className="text-white">AtZBusinessPartners株式会社</strong><br />
              〒150-0042 東京都渋谷区宇田川町1-12-1405<br />
              お問い合わせ：<a href="mailto:projectmaster@atz-bp.co.jp" className="text-amber-400 hover:text-amber-300 underline">projectmaster@atz-bp.co.jp</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}